export default __webpack_public_path__ + "static/media/header-logo.068883b7.svg";